module.exports = __webpack_public_path__ + "img/ta2.6e1b1f96.png";